<p-panel [toggleable]="true" toggler="header">
  <ng-template #header>
    <app-panel-header
      titleKey="project.steps.rfq.invitationPreview.previewPriceList.cardTitle.implementation.fees"
      tooltipKey="project.steps.rfq.invitationPreview.previewPriceList.cardTitle.implementation.fees.tooltip"
      [title]="feeCategories.findLabel('implementation').title"
      [tooltip]="feeCategories.findLabel('implementation').tooltip"
    ></app-panel-header>
    <span class="panel-header-key-value">
      <span> {{ 'common.total' | transloco }}: </span>
      <span class="font-bold text-fuchsia-500">
        {{ this.grandTotalAllYears() | appCurrency: inputObject() : 0 : 0 }}
      </span>
    </span>
  </ng-template>
  <ng-template #headericons let-collapsed>
    <i class="pi" [ngClass]="collapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
  </ng-template>

  <form [formGroup]="theForm">
    <ng-container formArrayName="data">
      <p-table
        [value]="feeRows()"
        [responsiveLayout]="'scroll'"
        class="square-table"
        [rowTrackBy]="trackByIndex"
      >
        <ng-template #caption>
          <div class="flex justify-end">
            <app-table-expand-controls (expandAll)="expandAll()" (collapseAll)="collapseAll()" />
          </div>
        </ng-template>
        <ng-template #header>
          <tr>
            <th style="width: 4rem"></th>
            <th>{{ 'common.functions' | transloco }}</th>
            <th class="w-[13%] text-right">{{ 'project.steps.rfq.hourlyRate' | transloco }}</th>
            @for (year of inputObject().scopeYears; track year) {
              <th class="w-[9%] text-right">{{ 'common.year' | transloco }} {{ year }}</th>
            }

            <th class="w-[9%] text-right">{{ 'common.total' | transloco }}</th>
            <th class="w-[3%] text-right">{{ 'common.comment' | transloco }}</th>
          </tr>
        </ng-template>

        <ng-template #body let-row let-rowIndex="rowIndex">
          @if (isParent(row.rowType)) {
            <tr [formGroupName]="row.formGroupIndex">
              <td>
                <p-button
                  type="button"
                  severity="secondary"
                  [text]="true"
                  [rounded]="true"
                  [icon]="row.isVisible ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                  (click)="expandItem(row)"
                />
              </td>
              <td [ngClass]="{'font-bold': true}">
                {{ row.implementationContainerDirectus | translateDirectus }}
              </td>
              <td class="w-[13%] text-right">
                <app-form-field-number
                  [id]="'hourlyRate-' + rowIndex"
                  [icon]="extractCurrencyIcon(inputObject().currencyCode)"
                  fieldName="hourlyRate"
                  [locale]="inputObject().locale"
                  [showButtons]="false"
                  [mode]="'decimal'"
                  [isReadOnly]="isReadOnly()"
                ></app-form-field-number>
              </td>
              @for (fee of row.yearlyFees; track $index) {
                <td class="w-[9%] text-right">
                  {{ fee.feePerUnit | appUnitHourly }}
                </td>
              }
              <td class="w-[9%] text-right font-semibold">
                {{ row.totalAcrossScope | appUnitHourly }}
              </td>
              <td class="w-[3%] text-right">
                <app-comment-modal-button
                  [isReadOnly]="isReadOnly()"
                  [control]="theForm.get('data.' + row.formGroupIndex + '.comment')"
                ></app-comment-modal-button>
              </td>
            </tr>
          }

          @if (isChild(row.rowType) && row.isVisible) {
            <tr [formGroupName]="row.formGroupIndex">
              <td></td>
              <td>
                <span class="pl-6">
                  {{ row.implementationContainerDirectus | translateDirectus }}
                </span>
              </td>
              <td class="w-[13%] text-right"></td>
              <ng-container formArrayName="implementationFunctionFeesResponse">
                <ng-container [formGroupName]="row.childIndex">
                  <ng-container formArrayName="implementationYearlyFees">
                    @for (fee of row.yearlyFees; track $index) {
                      <td [formGroupName]="$index" class="w-[9%] text-right">
                        <app-form-field-number
                          [id]="'fee-' + rowIndex + '-' + $index"
                          fieldName="feePerUnit"
                          [locale]="inputObject().locale"
                          [showButtons]="false"
                          [mode]="'integer'"
                          [isReadOnly]="isReadOnly()"
                        ></app-form-field-number>
                      </td>
                    }
                  </ng-container>
                </ng-container>
              </ng-container>
              <td class="w-[9%] text-right font-semibold">
                {{ row.totalAcrossScope | appUnitHourly }}
              </td>
              <td class="w-[3%] text-right"></td>
            </tr>
          }

          @if (isSum(row.rowType)) {
            <tr class="sum-row font-bold">
              <td></td>
              <td class="bg-slate-600/50">{{ 'common.cost' | transloco }}</td>
              <td class="bg-slate-600/50 w-[13%]"></td>
              @for (fee of row.yearlyFees; track $index) {
                <td class="bg-slate-600/50 w-[9%] text-right">
                  {{ fee.feePerUnit | appCurrency: inputObject() : 0 : 0 }}
                </td>
              }
              <td class="bg-slate-600/50 w-[9%] text-right">
                {{ row.totalAcrossScope | appCurrency: inputObject() : 0 : 0 }}
              </td>
              <td class="w-[3%] text-right"></td>
            </tr>
          }
        </ng-template>
        <ng-template #footer>
          <tr class="font-bold">
            <td>{{ 'common.total' | transloco }}</td>
            <td></td>
            <td class="w-[13%]"></td>
            @for (year of inputObject().scopeYears; track year) {
              <td class="w-[9%] text-right">
                {{ columnTotalsPerYear()[$index] | appCurrency: inputObject() : 0 : 0 }}
              </td>
            }
            <td class="w-[9%] text-right">
              {{ grandTotalAllYears() | appCurrency: inputObject() : 0 : 0 }}
            </td>
            <td class="w-[3%]"></td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>

    @if (!isReadOnly() && theForm.valid && hasChanges()) {
      <div class="flex justify-end gap-2 mt-4">
        <app-project-step-save-button
          [loading]="isSaving()"
          [disabled]="isSaving()"
          (clicked)="onSubmit()"
        ></app-project-step-save-button>
      </div>
    }
  </form>
</p-panel>
